import React, { useState, useContext, useEffect } from "react";
import { AuthContext } from "../context/auth";
import Footers from "../components/foother";
import AuthRoute from "../util/AuthRoute";
import Inicio from "./inicio";
import Header from "../components/header";
import Sidebar from "../components/sidebar";
import { Mensaje } from "../components/mensajes";
import TablaBancos from "../components/banco/tablaBancos";

/* almacen */
import TablaAlmacen from "../components/almacen/nuevaTablaAlmacen";
import TablaUbicacion from "../components/almacen/nuevaTablaUbicacion";
import TablaUnidMedidas from "../components/almacen/tablaUnidadesMedidas";
import TablaDepartamento from "../components/almacen/tablaDepartamento";
import TablaMarca from "../components/almacen/tablaMarca";
import TablaModelo from "../components/almacen/tablaModelo";
import TablaTipoProducto from "../components/almacen/tablaTipoProducto";
import TablaProdTerminadoe from "../components/almacen/tablaProductosTemrinados";
import TablaClientes from "../components/ventas/tablaClientes";
import TablaOperInventario from "../components/almacen/tablaOperInventario";
import TablaOperInventarioVacio from "../components/almacen/tablaOperInventariovacio";
import TablaVendedores from "../components/ventas/tablaVendedores";
import TablaProveedor from "../components/ventas/tablaProveedor";
import TablaBeneficiarios from "../components/finanzas/tablaBeneficiarios";
import TablaCuentas from "../components/finanzas/tablaCuentasBancarias";
import PanelPedidos from "../components/ventas/panelPedidos";
import TablaMovimientosBancos from "../components/finanzas/tablaMovimientoBancos";
import TablaMovimientosTransito from "../components/contabilidad/tablaMovimientoTransito";
import TablaOrdenCompra from "../components/compra/tablaOrdenCompra";
import TablaNotaEntrega from "../components/ventas/tablaNotaEntrega";
import TablaFactura from "../components/ventas/tablaFactura";
import TablaPresupuesto from "../components/ventas/tablaPresupuesto";
import TablaConciliacion from "../components/finanzas/tablaConciliacion";
import GestionCuentasCobrar from "../components/finanzas/gestionCuentasCobrar";
import fileExcel from "../components/almacen/archivosExcel";
import GestionCuentasPagar from "../components/finanzas/gestionCuentasPagar";
import TablaFactOrdenCompra from "../components/compra/tablaFacturaOrdenCompra";
import TablaTipoRetenciones from "../components/finanzas/tablaRetenciones";
import TablaCatalogoCuentaContable from "../components/contabilidad/catalogoCuentasContable";
import TablaAsientosContables from "../components/contabilidad/asientosContables";
import TablaNotaDebito from "../components/ventas/tablaNotaDebito";
import TablaNotaCredito from "../components/ventas/tablaNotaCredito";
import TablaAnticipos from "../components/finanzas/tablaAnticipo";
import ReversarTransaccion from "../components/finanzas/reversarPago";
import FileExcelClientes from "../components/almacen/archivosExcelCliente";
import GestionVacios from "../components/vacios/tablaVacios";
import ClassVacios from "../components/vacios/tablaClassVacios";
import TablaOrdenServicios from "../components/servicios/tablaOrdenServicios";
import GestionMoviles from "../components/servicios/tablaGestionMoviles";
import TablapServicios from "../components/servicios/tablaServicios";
import TablaNotaEntregaServicios from "../components/servicios/tablaNotaEntrega";
import TablaPosVenta from "../components/ventas/tablaPostVenta";
import TablaFacturaxNota from "../components/ventas/tablaFacturaxNota";
import { GestionGerencial } from "../components/gestionGerencial";



function MenuImpuestoPP() {
  const { user } = useContext(AuthContext);
  const pathname = window.location.pathname;

  pathname === "/" ? "login" : pathname.substr(1);
  const [path, setPath] = useState(pathname.substr(1));
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
  });
  const [titulo, setTitulo] = useState();

  const cambiar = (c) => {
    setPath(c);
    setTitulo(c);
  };

  useEffect(() => {
    if (pathname === "/inicio") {
      setTitulo("Inicio");
    } else if (pathname === "/registroalmacen") {
      setTitulo("Registro de Almacenes");
    } else if (pathname === "/ubicacionalmacen") {
      setTitulo("Ubicaciones de almacén");
    } else if (pathname === "/unidadmedidas") {
      setTitulo("Registro Unidades de Medida");
    } else if (pathname === "/departamento") {
      setTitulo("Registro de Departamento");
    } else if (pathname === "/marca") {
      setTitulo("Registro de Marcas");
    } else if (pathname === "/modelo") {
      setTitulo("Registro de Modelos");
    } else if (pathname === "/vendedores") {
      setTitulo("Registro de Vendedores");
    } else if (pathname === "/proveedores") {
      setTitulo("Registro de Proveedores");
    } else if (pathname === "/clientes") {
      setTitulo("Registro de Clientes");
    } else if (pathname === "/beneficiarios") {
      setTitulo("Registro de Beneficiarios");
    } else if (pathname === "/cuentasbancarias") {
      setTitulo("Registro de Cuentas Bancarias");
    } else if (pathname === "/movimientobanca") {
      setTitulo("Movimientos Bancarios");
    } else if (pathname === "/operacionesinv") {
      setTitulo("Operaciones de inventario");
    } else if (pathname === "/movimientotransi") {
      setTitulo("Movimientos Bancarios en Transito");
    } else if (pathname === "/producto") {
      setTitulo("Registro de Producto");
    } else if (pathname === "/ordencompra") {
      setTitulo("Ordenes de compra");
    } else if (pathname === "/pedidos") {
      setTitulo("Pedidos");
    } else if (pathname === "/notaentrega") {
      setTitulo("Notas de Entrega");
    } else if (pathname === "/notadebito") {
      setTitulo("Notas de Debito");
    } else if (pathname === "/notacredito") {
      setTitulo("Notas de Credito");
    } else if (pathname === "/factura") {
      setTitulo("Facturas");
    } else if (pathname === "/conciliacion") {
      setTitulo("Conciliación Bancaria");
    } else if (pathname === "/cuentasxcobrar") {
      setTitulo("Cuentas por Cobrar");
    } else if (pathname === "/cuentasxpagar") {
      setTitulo("Cuentas por Pagar");
    } else if (pathname === "/excel") {
      setTitulo("Actualización por Archivo XLSX");
    } else if (pathname === "/presupuesto") {
      setTitulo("Modulo de Presupuestos");
    } else if (pathname === "/facturarordencompra") {
      setTitulo("Facturación de Compras");
    } else if (pathname === "/tiporetenciones") {
      setTitulo("Tipo de Retenciones");
    } else if (pathname === "/catalogoContable") {
      setTitulo("Plan de Cuentas Contables");
    } else if (pathname === "/asientoscontables") {
      setTitulo("Asientos Contables");
    } else if (pathname === "/anticipos") {
      setTitulo("Anticipos");
    } else if (pathname === "/controlvacios") {
      setTitulo("Control de Vacios");
    } else if (pathname === "/classvacios") {
      setTitulo("Clasificador de Vacios");
    } else if (pathname === "/orderservicio") {
      setTitulo("Gestionar Ordenes");
    } else if (pathname === "/gestionmoviles") {
      setTitulo("Gestión de Móviles");
    } else if (pathname === "/gestionservicios") {
      setTitulo("Getionar Servicios");
    } else if (pathname === "/notaentregaserv") {
      setTitulo("Gestionar Notas de Entrega por Ordenes");
    }
  }, [pathname]);

  const menu = user && (
    <div className="h-100 w-100">
      <div className="d-flex bluex-bg h-100 w-100" id="wrapper">
        {path === "inicio" && <Sidebar onCambiar={cambiar} />}
        <div className="h-100 w-100" id="page-content-wrapper">
          <Header path={path} titulo={titulo} onCambiar={cambiar} />

          <div className="w-100 h-90" id="scrol">
            <AuthRoute exact path="/inicio" component={Inicio} />
            <AuthRoute exact path="/bancos" component={TablaBancos} />
            {/* Gestion Gerencia */}

            <AuthRoute exact path="/gestionGerencial" component={GestionGerencial} />

            {/* ALmacen */}
            <AuthRoute exact path="/registroalmacen" component={TablaAlmacen} />
            <AuthRoute
              exact
              path="/ubicacionalmacen"
              component={TablaUbicacion}
            />
            <AuthRoute
              exact
              path="/unidadmedidas"
              component={TablaUnidMedidas}
            />
            <AuthRoute
              exact
              path="/departamento"
              component={TablaDepartamento}
            />
            <AuthRoute exact path="/marca" component={TablaMarca} />
            <AuthRoute exact path="/modelo" component={TablaModelo} />
            <AuthRoute
              exact
              path="/tipoproducto"
              component={TablaTipoProducto}
            />
            <AuthRoute exact path="/producto" component={TablaProdTerminadoe} />
            <AuthRoute exact path="/clientes" component={TablaClientes} />
            <AuthRoute
              exact
              path="/operacionesinv"
              component={TablaOperInventario}
            />
            <AuthRoute
              exact
              path="/operacionesinvacio"
              component={TablaOperInventarioVacio}
            />
            <AuthRoute
              exact
              path="/orderservicio"
              component={TablaOrdenServicios}
            />
            <AuthRoute
              exact
              path="/gestionmoviles"
              component={GestionMoviles}
            />
            <AuthRoute
              exact
              path="/gestionservicios"
              component={TablapServicios}
            />
            <AuthRoute exact path="/vendedores" component={TablaVendedores} />
            <AuthRoute exact path="/proveedores" component={TablaProveedor} />
            <AuthRoute
              exact
              path="/beneficiarios"
              component={TablaBeneficiarios}
            />
            <AuthRoute
              exact
              path="/cuentasbancarias"
              component={TablaCuentas}
            />
            <AuthRoute exact path="/pedidos" component={PanelPedidos} />
            <AuthRoute
              exact
              path="/movimientobanca"
              component={TablaMovimientosBancos}
            />
            <AuthRoute
              exact
              path="/movimientotransi"
              component={TablaMovimientosTransito}
            />
            <AuthRoute exact path="/ordencompra" component={TablaOrdenCompra} />
            <AuthRoute exact path="/notaentrega" component={TablaNotaEntrega} />
            <AuthRoute exact path="/notadebito" component={TablaNotaDebito} />
            <AuthRoute exact path="/notacredito" component={TablaNotaCredito} />
            <AuthRoute exact path="/factura" component={TablaFactura} />
            <AuthRoute
              exact
              path="/facturaxnota"
              component={TablaFacturaxNota}
            />
            <AuthRoute exact path="/presupuesto" component={TablaPresupuesto} />
            <AuthRoute exact path="/postventa" component={TablaPosVenta} />
            <AuthRoute
              exact
              path="/conciliacion"
              component={TablaConciliacion}
            />
            <AuthRoute
              exact
              path="/reversarpago"
              component={ReversarTransaccion}
            />
            <AuthRoute
              exact
              path="/cuentasxcobrar"
              component={GestionCuentasCobrar}
            />
            <AuthRoute exact path="/excel" component={fileExcel} />
            <AuthRoute
              exact
              path="/excelclientes"
              component={FileExcelClientes}
            />
            <AuthRoute
              exact
              path="/cuentasxpagar"
              component={GestionCuentasPagar}
            />
            <AuthRoute
              exact
              path="/facturarordencompra"
              component={TablaFactOrdenCompra}
            />
            <AuthRoute
              exact
              path="/tiporetenciones"
              component={TablaTipoRetenciones}
            />
            <AuthRoute
              exact
              path="/catalogoContable"
              component={TablaCatalogoCuentaContable}
            />
            <AuthRoute
              exact
              path="/asientoscontables"
              component={TablaAsientosContables}
            />
            <AuthRoute exact path="/anticipos" component={TablaAnticipos} />
            <AuthRoute exact path="/controlvacios" component={GestionVacios} />
            <AuthRoute exact path="/classvacios" component={ClassVacios} />
            <AuthRoute
              exact
              path="/notaentregaserv"
              component={TablaNotaEntregaServicios}
            />
          {/*     <AuthRoute
              exact
              path="/print"
              component={Print}
            />
           */}
          </div>
        </div>
      </div>
      <Footers />
      <Mensaje
        mensaje={mensaje}
        onHide={() => setMensaje({ mostrar: false, titulo: "", texto: "" })}
      />
    </div>
  );
  return menu;
}
export default MenuImpuestoPP;



// WEBPACK FOOTER //
// ./src/pages/escritorio.js